/* eslint-disable max-len */
import React, { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const TrendUp: FC<AllieIconProps> = ({ color = '#667085', allieColor, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M22.5 7L14.6314 14.8686C14.2354 15.2646 14.0373 15.4627 13.809 15.5368C13.6082 15.6021 13.3918 15.6021 13.191 15.5368C12.9627 15.4627 12.7646 15.2646 12.3686 14.8686L9.63137 12.1314C9.23535 11.7354 9.03735 11.5373 8.80902 11.4632C8.60817 11.3979 8.39183 11.3979 8.19098 11.4632C7.96265 11.5373 7.76465 11.7354 7.36863 12.1314L2.5 17M22.5 7H15.5M22.5 7V14"
        stroke={allieColor ? `var(--allie-color-${allieColor})` : color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
